module.exports = __webpack_public_path__ + "static/media/HatchyPockets.bb31be61.jpg";